import {
    AccessSegment,
    ColumnMetadata,
    ColumnTypes,
} from "~/components/DataGrid";
import { AssetColumns } from "~/modules/assets/types";
import { Emdash } from "~/components/Punctuation";
import { AssetTableRowData } from "../types";

// // // //

export const DISPUTE_RESOLUTION_COUNTRY_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: "dispute_resolution_country",
    label: "Dispute Resolution Country",
    type: ColumnTypes.string,
    width: 410,
    access: {
        view: AccessSegment.Preview,
        sort: AccessSegment.Preview,
    },
    render: (item) => {
        if (item.isAsset) {
            if (
                !item.dispute_resolution_country_id &&
                !item.dispute_resolution_country_name
            ) {
                return <Emdash />;
            }

            return (
                <div className="flex flex-col">
                    <p className="text-foreground dg-overflow">
                        {item.dispute_resolution_country_name}
                    </p>
                </div>
            );
        }

        return <Emdash />;
    },
};
